import { render } from "./Testimonials.vue?vue&type=template&id=407244cb&scoped=true&ts=true"
import script from "./Testimonials.vue?vue&type=script&lang=ts"
export * from "./Testimonials.vue?vue&type=script&lang=ts"

import "./Testimonials.vue?vue&type=style&index=0&id=407244cb&lang=scss&scoped=true"
import "./Testimonials.vue?vue&type=style&index=1&id=407244cb&lang=scss"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407244cb"]])

export default __exports__